import React from "react";
import { Container, Button } from "react-bootstrap";
import { MdArrowForward } from "react-icons/md";
import "./CheckInLanding.css";

const Organization = () => {
    return (
        <section className="organization-section">
            <Container>
                <div className="organization-box">

                    <div className="organization-content">
                        <h3 className="organization-title">
                            Want to sign your organization up?
                        </h3>

                        <p className="organization-text">
                            Enroll members of your sorority, senior community, or church and
                            get 15% off the Premium Plan. Add as many users as you want.
                            Don't see your organization type? Reach out and we'll find a way.
                        </p>
                    </div>

                    <Button className="organization-btn">
                        Contact us
                        <MdArrowForward size={18} className="ms-2" />
                    </Button>

                </div>
            </Container>
        </section>
    );
};

export default Organization;